export default __webpack_public_path__ + "static/media/OpenSans-ExtraBold.110e781b.ttf";